import { Result } from "../../models/result";

export function sortCityAscending(a: Result, b: Result) {
	if (a === undefined || b === undefined) {
		return 0;
	}

	if (a.city < b.city) {
		return -1;
	}
	if (a.city > b.city) {
		return 1;
	}

	return 0;
}
